<template>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="svg_1" class="fill-primary" d="m40.30178,28.80993l0,8.2327l-32.8443,0l1.08261,-8.2327l31.76169,0z" clip-rule="evenodd" fill-rule="evenodd"/>
        <path id="svg_2" class="fill-primary-alt" d="m40.30148,12.82993l0,8.2327l-16.4221,0l1.0826,-8.2327l15.3395,0z" clip-rule="evenodd" fill-rule="evenodd"/>
    </svg>
</template>

<script>
export default {
    name: 'icon-hexeko'
}
</script>